export default __webpack_public_path__ + "static/media/trickHealthgenom.da77dfe5.svg";